import { Statistic } from './stats';
import Testimonial from './testimonial';
import TimeLine from './timeline';
import CtaSection from './cta';
import FirstSection from './fFirstSection';
import { About } from './About';
import { ForWho } from './ForWho';
import Register from './Register';
import callouts from '../../../data/services';
import RegCta from './regCTA';
import Prices from './prices';
import { Helmet } from 'react-helmet';
import BeforeAfter from '../../../component/BeforeAfter';

const stickyButtonStyle = {
  position: 'sticky',
  bottom: '0px', // Adjust the value as per your requirement

  zIndex: 999, // Adjust the z-index value if needed to ensure it stays above other elements
  marginTop: '0px',
};

function Shapeup() {
  const ogData = {
    title: 'لاغری اصولی با دوره نیمه خصوصی شیپ آپ - آذر شفیعی',
    description:
      'در این دوره یاد میگیرید : بدون ترس از غذاخوردن، به تناسب اندام برسید. اگر رژیم های مختلفی را امتحان کردید و به نتیجه نرسیدید، شیپ آپ راه حل شماست',
    url: 'https://www.azishafiei.com',
    image: 'https://azishafiei.com/static/media/azi.d0bac2347aeb47da4bbf.jpg',
    siteName: 'آذر شفیعی',
  };
  return (
    <div>
      <Helmet
        title="لاغری اصولی با دوره نیمه خصوصی شیپ آپ - آذر شفیعی"
        meta={[
          {
            name: 'description',
            content:
              'در این دوره سه ماهه، شما با اصول اصلی تغذیه سالم آشنا خواهید شد، هر هفته در جلسات شرکت کرده و بر اساس وزن و وضعبت جسمی، به شما برنامه داده خواهد شد. در انتهای دوره، شما میتوانید بدون نیاز به دیگران، برنامه تغذیه مناسب برای خود داشته باشید',
          },
        ]}
      />
      <FirstSection />
      <div className="bg-white ">
        <Statistic />
        <BeforeAfter />
      </div>
      <Testimonial />
      {/* <img src={TimeLinePng} alt="timeline" className="w-full" /> */}
      <TimeLine />
      <About />
      <CtaSection />
      <ForWho />
      <Register />
      <Prices />
      <div className="bg-gold" style={stickyButtonStyle}>
        {/* <RegButton data={callouts[0]} /> */}
        <RegCta data={callouts[0]} />
      </div>
    </div>
  );
}

export default Shapeup;
